module.exports = __webpack_public_path__ + "img/step3_pay.05092973.png";